/**
 * Icon Map Utility
 * =================
 * Maps string icon names to Lucide React icon components.
 * Used to convert FEATURES icon strings to actual rendered icons.
 */

import {
  Brain,
  TrendingUp,
  LayoutDashboard,
  FileText,
  Plug,
  Sparkles,
} from 'lucide-react';

/**
 * Icon component mapping
 * Maps string names to Lucide React icon components
 */
export const ICON_MAP = {
  Brain,
  TrendingUp,
  LayoutDashboard,
  FileText,
  Plug,
  Sparkles,
};

/**
 * Get icon component by name
 * @param {string} iconName - Name of the icon
 * @param {object} props - Props to pass to the icon component
 * @returns {JSX.Element|null} Icon component or null if not found
 */
export function getIcon(iconName, props = {}) {
  const IconComponent = ICON_MAP[iconName];
  if (!IconComponent) {
    console.warn(`Icon "${iconName}" not found in ICON_MAP`);
    return null;
  }
  return <IconComponent {...props} />;
}

/**
 * Icon component that renders based on string name
 * @param {object} props - Component props
 * @param {string} props.name - Icon name
 * @param {string} [props.className] - Additional CSS classes
 * @param {number} [props.size] - Icon size
 * @returns {JSX.Element|null} Icon component
 */
export function Icon({ name, className = '', size = 24, ...props }) {
  const IconComponent = ICON_MAP[name];
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in ICON_MAP`);
    return null;
  }
  return <IconComponent className={className} size={size} {...props} />;
}

export default ICON_MAP;
